'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _facets = require('../components/facets');

var _facets2 = _interopRequireDefault(_facets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return {
        groups: state.facets.groups.length > 0 ? state.facets.groups : ownProps.groups || []
    };
}

var mapDispatchToProps = {
    change: _actions2.default.change
};

var FacetsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
    (0, _inherits3.default)(FacetsContainer, _React$Component);

    function FacetsContainer() {
        (0, _classCallCheck3.default)(this, FacetsContainer);
        return (0, _possibleConstructorReturn3.default)(this, (FacetsContainer.__proto__ || (0, _getPrototypeOf2.default)(FacetsContainer)).apply(this, arguments));
    }

    (0, _createClass3.default)(FacetsContainer, [{
        key: 'render',
        value: function render() {
            var groups = this.props.groups || [];
            return _react2.default.createElement(_facets2.default, { groups: groups, onChange: this.props.change });
        }
    }]);
    return FacetsContainer;
}(_react2.default.Component), _class2.propTypes = {
    groups: _react2.default.PropTypes.array.isRequired,
    change: _react2.default.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = FacetsContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/containers/facets.js
// module id = 1045
// module chunks = 0